/** How the caller established the selected Athena insurance package. */
export enum AthenaInsurancePackageResolutionSource {
  AGENT = "agent",
  AGENT_EXTRACTION = "agent_extraction",
  ATHENA_SEARCH = "athena_search",
  CONFIGURED = "configured",
  CONFIRMED_CATALOG = "confirmed_catalog",
  EXISTING = "existing",
}

export function isAgentInsurancePackageResolution(source: AthenaInsurancePackageResolutionSource | undefined): boolean {
  return (
    source === AthenaInsurancePackageResolutionSource.AGENT ||
    source === AthenaInsurancePackageResolutionSource.AGENT_EXTRACTION
  );
}
